import { scheduleConstraintLabels } from 'features/schedule-configuration';
import type { ScheduleConstraintCode } from 'services/api';

export const getViolationLabel = (code: ScheduleConstraintCode) =>
  scheduleConstraintLabels[code] ?? code;
